// extracted by mini-css-extract-plugin
export default {"isFirstMessage":"index-module--isFirstMessage--dc5ea","timestamp":"index-module--timestamp--f773d","balloon":"index-module--balloon--9a049"};